import React, { useState, createContext, useContext } from "react";

interface BackContextType {
   isBackClicked: boolean;
   setIsBackClicked: React.Dispatch<React.SetStateAction<boolean>>;
}
// Create a Context
const BackContextView = createContext<BackContextType | undefined>(undefined);

// Create a Provider component
export const BackContextProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
   const [isBackClicked, setIsBackClicked] = useState(false);

   return (
      <BackContextView.Provider value={{ isBackClicked, setIsBackClicked }}>
         {children}
      </BackContextView.Provider>
   );
};

// Custom hook for consuming the context
export const useBackContext = () => {
   const context = useContext(BackContextView);
   if (!context) {
      throw new Error("useBackContext must be used within a BackContextProvider");
   }
   return context;
};
